import { render, staticRenderFns } from "./TaskCommentsModal.vue?vue&type=template&id=2f8ad0ce&scoped=true&"
import script from "./TaskCommentsModal.vue?vue&type=script&lang=js&"
export * from "./TaskCommentsModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskCommentsModal.vue?vue&type=style&index=0&id=2f8ad0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ad0ce",
  null
  
)

export default component.exports